import React, { useRef } from 'react'
import { Button, Modal } from 'react-bootstrap';
import updateTicketDetail from '../../service/api/ticket/updateTicketDetail';
import { updateServiceReqModalFalse } from '../../feature/userData/userData'
import './updateServiceRequest.scss'

import TextArea from '../../jsx/components/fields/textArea';
import SelectInputTimeSlot from '../../jsx/components/fields/selectInputTimeSlot';
import SelectInputCommunicationMode from '../../jsx/components/fields/selectInputComMode';
import PrimaryButton from '../../jsx/components/button/primaryButton';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { useState } from 'react';
import { useEffect } from 'react';
import serviceImg from '../../media/images/serviceImg.gif'
import InputField from '../../jsx/components/fields/inputField';

const UpdateServiceRequest = ({ objectCategoryName, descriptionVal, modelNumVal, timeSlotArr, communicationModeArr, attachedImg }) => {
    const { role, backDropLoaderStatus, updateServiceRequestStatus } = useSelector((state) => state.user);
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const [staticButtonUpdateTicket, setStaticButtonUpdateTicket] = useState(true);
    const [saveUpdateTicketLoading, setSaveUpdateTicketLoading] = useState(false);


    const [modelNum, setModelNum] = useState(modelNumVal ? modelNumVal : "");
    const [isDescrError, setIsDescrError] = useState(false);
    const [description, setDescription] = useState(descriptionVal ? descriptionVal : "");
    const [timeSlotID, setTimeSlotID] = useState(4);
    const [communicationModeID, setCommunicationModeID] = useState(3);

    const [timeSlotCheck, setTimeSlotCheck] = useState(false);
    const [communicationModeCheck, setCommunicationModeCheck] = useState(false);

    // Attaching the multiple images
    const [uploadAttachedImage0, setUploadAttachedImage0] = useState(attachedImg);
    // const [attachedImage0, setAttachedImage0] = useState(URL?.createObjectURL(attachedImg));

    const [uploadAttachedImage1, setUploadAttachedImage1] = useState(null);
    const [attachedImage1, setAttachedImage1] = useState(null);

    const [uploadAttachedImage2, setUploadAttachedImage2] = useState(null);
    const [attachedImage2, setAttachedImage2] = useState(null);

    const [currentDate, setCurrentDate] = useState(new Date().toISOString().split('T')[0]);

    // Attachment Upload 1
    const attachedImage1Ref = useRef();

    const handleClickAttachedImage1 = () => {
        attachedImage1Ref.current.click();
    }
    function handleAttachedImage1(e) {
        if (e.target.files) {
            setUploadAttachedImage1(e.target.files[0]);
            setAttachedImage1(URL.createObjectURL(e.target.files[0]))
        }
    }

    function deleteAttachedImage1() {
        setUploadAttachedImage1(null);
        setAttachedImage1(null)
    }

    // Attachment Upload 2
    const attachedImage2Ref = useRef();

    const handleClickAttachedImage2 = () => {
        attachedImage2Ref.current.click();
    }
    function handleAttachedImage2(e) {
        if (e.target.files) {
            setUploadAttachedImage2(e.target.files[0]);
            setAttachedImage2(URL.createObjectURL(e.target.files[0]))
        }
    }

    function deleteAttachedImage2() {
        setUploadAttachedImage2(null);
        setAttachedImage2(null)
    }

    function updateServiceRequestFn(e) {
        e.preventDefault();

        if (timeSlotID === 0 && communicationModeID === 0) {
            setTimeSlotCheck(true);
            setCommunicationModeCheck(true);
            return;
        }

        if (timeSlotID === 0) {
            setTimeSlotCheck(true);
            return;
        }
        if (communicationModeID === 0) {
            setCommunicationModeCheck(true);
            return;
        }

        setSaveUpdateTicketLoading(true);

        const unixTimestamp = Math.floor(new Date(currentDate).getTime() / 1000);

        let formData = new FormData();

        formData.append("ticket_id_ids", localStorage.getItem("ticket_id"));
        formData.append("time_slot_id", parseInt(timeSlotID))
        formData.append("communication_mode_id", parseInt(communicationModeID));
        // formData.append("address_id_ids", 0);
        localStorage.getItem("proType") !== "null" && formData.append("product_type_chr", localStorage.getItem("proType") || '')
        formData.append("product_category_chr", objectCategoryName)
        modelNum && formData.append("model_number_chr", modelNum)
        description && formData.append("problem_description_chr", description);
        uploadAttachedImage1 != null && formData.append("attachment_id_ids0", "");
        uploadAttachedImage1 != null && formData.append("attachment0", uploadAttachedImage1);
        uploadAttachedImage2 != null && formData.append("attachment_id_ids1", "")
        uploadAttachedImage2 != null && formData.append("attachment1", uploadAttachedImage2)
        // uploadAttachedImage2 != null && formData.append("attachment_id_ids2", 0)
        // uploadAttachedImage2 != null && formData.append("attachment2", uploadAttachedImage2)
        formData.append("unix_datetime_stamp_start", unixTimestamp);

        dispatch(updateTicketDetail(formData, (res) => {
            setSaveUpdateTicketLoading(false);
            setToggleUpdate(false);
            // handleClose();
            // navigate("/particularTicketDetails");
        }, (err) => {
            setSaveUpdateTicketLoading(false);
        }))

    }

    function updateTimeSlotFn(e) {
        setTimeSlotCheck(false);
        setTimeSlotID(e.target.value);
    }

    function updateCommunicationModeFn(e) {
        setCommunicationModeCheck(false);
        setCommunicationModeID(e.target.value);
    }

    function handleDescription(e) {
        console.log(e.target.value);
        setIsDescrError(false)
        setDescription(e.target.value);
    }

    function handleModelNumber(e) {
        setModelNum(e.target.value);
    }

    function skipUpdates(e) {
        e.preventDefault();
        handleClose();
        navigate("/serviceRequest")
    }

    const [openUpdateService, setopenUpdateService] = useState(true);
    const handleClose = () => {
        setopenUpdateService(false);
        dispatch(updateServiceReqModalFalse());
    }
    const [width, setWidth] = useState(0);
    useEffect(() => {
        setWidth(window.screen.width);

    }, [window.screen.width])

    window.addEventListener("resize", () => {
        setWidth(window.screen.width);
    });

    const [toggleUpdate, setToggleUpdate] = useState(true);

    const closeConfirmation = () => {
        handleClose();
        navigate("/serviceRequest");
    }

    // Preview for the image
    const [documentType, setDocumentType] = useState();
    const [openDoc, setOpenDoc] = React.useState(false);
    const handleOpenDoc = (docType) => {
        setDocumentType(docType);
        setOpenDoc(true);
    }
    const handleCloseDoc = () => setOpenDoc(false);
    return (
        <>
            <Modal className="fade" show={updateServiceRequestStatus}
                // onHide={handleClose} 
                centered
            >
                <Modal.Header style={{ borderBottom: 'none' }}>
                    <Modal.Title >
                        {toggleUpdate ? 'Service Request Follow-up' : ''}
                    </Modal.Title>

                    {!toggleUpdate && <Button
                        variant=""
                        className="btn-close btn-close-service"
                        onClick={(e) => closeConfirmation(e)}
                    >

                    </Button>}

                </Modal.Header>
                <Modal.Body>
                    {toggleUpdate ?
                        <>
                            <form onSubmit={(e) => updateServiceRequestFn(e)} >
                                {/* <TextArea
                                    onChange={handleDescription}
                                    value={description}
                                    labelName={"Description"}
                                    errorOccured={isDescrError}
                                    errorMessage={"Please provide description"}
                                /> */}
                                <div className="mx-0 row">
                                    <div className="col-12  px-0 text-center mb-3">
                                        <InputField
                                            type="date"
                                            labelName={"Date"}
                                            placeholder={"Date"}
                                            value={currentDate}
                                            onChange={(e) => setCurrentDate(e.target.value)}
                                            errorOccured={false}
                                            errorMeesage={"Please enter date"}
                                            onBlur={() => { }}
                                        />
                                    </div>
                                </div>

                                <div className='row mx-0'>
                                    <div className='col-12 px-0'>
                                        <SelectInputTimeSlot
                                            labelName={'Best Time To Contact'}
                                            onChange={(e) => updateTimeSlotFn(e)}
                                            defaultValue={timeSlotID}
                                            errorOccured={timeSlotCheck}
                                            errorMessage={'select your preferred time slot'}
                                            options={timeSlotArr}
                                        />
                                    </div>
                                </div>

                                {false &&
                                    <div className='combine-input-fileds' >
                                        <div className='comapany-address' style={{ width: '49%' }}>
                                            <SelectInputTimeSlot
                                                labelName={'Best Time To Contact'}
                                                onChange={(e) => updateTimeSlotFn(e)}
                                                defaultValue={timeSlotID}
                                                errorOccured={timeSlotCheck}
                                                errorMessage={'select your preferred time slot'}
                                                options={timeSlotArr}
                                            />
                                            {/* {timeSlotCheck && <span style={{ color: 'red', fontSize: '10px', }}>select your preferred time slot</span>} */}
                                        </div>
                                        <div className='comapany-address' style={{ width: '49%' }}>
                                            <SelectInputCommunicationMode
                                                labelName={'Best Contact Method'}
                                                onChange={(e) => updateCommunicationModeFn(e)}
                                                defaultValue={communicationModeID}
                                                errorOccured={communicationModeCheck}
                                                errorMessage={'select your preferred mode'}
                                                options={communicationModeArr}
                                            />
                                            {/* {communicationModeCheck && <span style={{ color: 'red', fontSize: '10px', }}>select your preferred mode</span>} */}

                                        </div>
                                    </div>
                                }


                                {/* Hide this section as per the feedback code required in future */}

                                {/* <div className='attachments-txt'>
                                    <span><strong>Attachments</strong></span>
                                </div>

                                <div className='update-attachment-img-container'>
                                    {attachedImg &&
                                        <div className='update-attachment-img-container-individual'>
                                            <img onClick={() => { handleOpenDoc(); setDocumentType(1) }} src={URL.createObjectURL(attachedImg)} alt="Attachments" className='update-attachment-img-individual' />
                                        </div>
                                    }

                                    {attachedImage1 ?
                                        <div className='update-attachment-img-container-individual'>
                                            <i onClick={() => { deleteAttachedImage1(); deleteAttachedImage2() }} className="bi bi-x-circle-fill attachment-img-delete-icon"></i>
                                            <img onClick={() => { handleOpenDoc(); setDocumentType(2) }} src={attachedImage1} alt="Attachments" className='update-attachment-img-individual' />
                                        </div> :
                                        <div className='update-attachment-img-container-individual' onClick={handleClickAttachedImage1}>
                                            <i className="bi bi-plus-circle-fill update-attachment-img-individual-icon"></i>
                                            <input ref={attachedImage1Ref} type="file" accept="image/*" hidden onChange={(e) => { handleAttachedImage1(e) }} />
                                        </div>
                                    }

                                    {attachedImage1 && <>
                                        {attachedImage2 ?
                                            <div className='update-attachment-img-container-individual'>
                                                <i onClick={() => { deleteAttachedImage2() }} className="bi bi-x-circle-fill attachment-img-delete-icon"></i>
                                                <img onClick={() => { handleOpenDoc(); setDocumentType(3) }} src={attachedImage2} alt="Attachments" className='update-attachment-img-individual' />
                                            </div> :
                                            <div className='update-attachment-img-container-individual' onClick={handleClickAttachedImage2}>
                                                <i className="bi bi-plus-circle-fill update-attachment-img-individual-icon"></i>
                                                <input ref={attachedImage2Ref} type="file" accept="image/*" hidden onChange={(e) => { handleAttachedImage2(e) }} />
                                            </div>}
                                    </>
                                    }

                                </div> */}

                                <div className='d-flex align-items-center w-100' >

                                    <PrimaryButton
                                        onClick={(e) => updateServiceRequestFn(e)}
                                        buttonName={'UPDATE SERVICE'}
                                        type={"submit"}
                                        loadingMessage={'Saving...'}
                                        isLoading={saveUpdateTicketLoading}
                                        style={{
                                            width: '100%',
                                            background: 'linear-gradient(142.98deg, #FF7401 1.99%, #FFA800 99.97%)',
                                            border: '2px solid rgba(255, 154, 32, 1)',
                                            boxShadow: '0px 6px 12px 0px rgba(255, 154, 32, 0.24)',
                                        }}
                                    />


                                    {/* <div style={{ marginLeft: '10px' }}>
                                        <PrimaryButton
                                            onClick={(e) => skipUpdates(e)}
                                            buttonName={'Close'}
                                        />
                                    </div> */}
                                </div>


                            </form>
                        </> :
                        <>
                            <div style={{ display: 'flex', flexDirection: 'column', position: 'relative', alignItems: 'center', textAlign: 'center' }}>
                                <img src={serviceImg} alt="" style={{ maxWidth: '150px' }} />

                                <span style={{ margin: '3px 20px', fontSize: '16px', fontWeight: 700, color: 'black', }}>
                                    Thank you for creating service request.
                                </span>
                                <span style={{ margin: '5px 20px', fontSize: '14px', fontWeight: 500, color: 'black', }}>
                                    Our Professional will get back to you at your preferred time slot.
                                </span>

                            </div>


                            {/* <div className='d-flex align-items-center' style={{ justifyContent: 'flex-end' }}>
                                <div >
                                    <PrimaryButton
                                        onClick={(e) => closeConfirmation(e)}
                                        buttonName={'Close'}
                                    />
                                </div>
                            </div> */}
                        </>
                    }
                </Modal.Body>
            </Modal>

            <>

                <Modal show={openDoc} onHide={handleCloseDoc} style={{ background: '#fff0', border: 'none', }}>

                    <div className='image-preview-modal-header'>
                        <span></span>

                        <div onClick={handleCloseDoc} className='image-preview-modal-action-btn-close'>
                            <i style={{ fontSize: '30px', }} className="bi bi-x"></i>
                        </div>
                    </div>

                    {documentType == 1 ?
                        <>
                            <img src={URL?.createObjectURL(attachedImg)} alt='Attachement 1' style={{ width: '100%', height: '100%' }} />
                        </>
                        :
                        documentType == 2 ?
                            <>
                                <img src={attachedImage1} alt='Attachement 2' style={{ width: '100%', height: '100%' }} />
                            </>
                            :
                            documentType == 3 ?
                                <>
                                    <img src={attachedImage2} alt='Attachement 3' style={{ width: '100%', height: '100%' }} />
                                </>
                                :
                                null
                    }
                </Modal>
            </>
        </>
    )
}

export default UpdateServiceRequest;